import styled, { createGlobalStyle } from 'styled-components';
import { COLOURS_AA } from 'components-stateless/DesignSystem/Atoms/Colours';

// Global styles for footer padding
export const FooterGlobalStyles = createGlobalStyle`
  body {
    padding-bottom: 50px;
  }
`;

export const FooterWrapper = styled.div`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  background-color: white;
  border-top: 1px solid #e0e0e0;
  z-index: 1000;

  .footer-content {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 1rem;
    gap: 0.5rem;
    flex-wrap: nowrap;

    @media (max-width: 768px) {
      gap: 0.5rem;
      padding: 0.75rem;
    }
  }
`;

export const FooterLink = styled.a`
  color: ${COLOURS_AA.tertiaryTxt.BtnTertiaryDarkDefault};
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 166.667% */
  text-decoration: none;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }

  &:focus {
    outline: 2px solid ${COLOURS_AA.links.TextLink};
    outline-offset: 2px;
  }
`;

export const Separator = styled.span`
  color: ${COLOURS_AA.tertiaryTxt.BtnTertiaryDarkDefault};
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px; /* 166.667% */
  margin: 0 0.25rem;
`;

export const LoadingText = styled.span`
  color: ${COLOURS_AA.tertiaryTxt.BtnTertiaryDarkDefault};
  font-family: Inter;
  font-size: 12px;
  font-style: italic;
  font-weight: 600;
  line-height: 20px; /* 166.667% */
`;
